namespace Areas.Dialogs {
    "use strict";

    export class AccountProfileImageDialog extends Areas.BaseDialog {

        constructor(closeHandler: (dialogResult: DialogResult, data: any) => void, parameters: any) {
            super("AccountProfileImage", closeHandler, parameters,
                () => {
                    const uploader = $("#fileUploaderControl").dxFileUploader("instance");
                    let url: any = uploader.option("uploadUrl");

                    url = updateQueryStringParameter(url, "accountId", this.parameters.accountId);
                    uploader.option("uploadUrl", url);
               });
        }

        protected ok = (e: any) => {
            this.close(DialogResult.Ok, null);
        }

    }

}